// extracted by mini-css-extract-plugin
export default {"invitationFooter":"Footer_invitationFooter__6enlf","navigationLinks":"Footer_navigationLinks__OD1Cq"};